import * as React from "react";

import { Colors, H1 } from "@blueprintjs/core";
import { css } from "glamor";

interface Props {
	steps: string[];
	currentIndex: number;
	dark: boolean;
}

const DOT_CONTAINER_WIDTH = 30;
const DOT_RADIUS = 6;
const LINE_WIDTH = 4;

const styles = {
	title: css({
		textAlign: "left",
	}),
	element: css({
		height: DOT_CONTAINER_WIDTH,
		display: "flex",
		alignItems: "center",
		textAlign: "left",
		paddingRight: "12px",
	}),
	elementText: css({
		flexGrow: "1",
		marginLeft: "15px",
	}),
	container: css({
		position: "relative",
	}),
	linesContainer: css({
		position: "absolute",
		top: 0,
		left: (DOT_CONTAINER_WIDTH - LINE_WIDTH) / 2,
		height: "100%",
		width: LINE_WIDTH,
	}),
	topLine: (dark: boolean) =>
		css({
			background: dark ? Colors.LIGHT_GRAY5 : Colors.DARK_GRAY3,
			zIndex: "1",
		}),
	bottomLine: (dark: boolean) =>
		css({
			background: dark ? Colors.DARK_GRAY5 : Colors.GRAY5,
		}),
	dotContainer: css({
		width: DOT_CONTAINER_WIDTH,
	}),
	dot: css({
		margin: "auto",
		width: DOT_RADIUS * 2,
		height: DOT_RADIUS * 2,
		borderRadius: "50%",
		zIndex: "99",
		position: "relative",
	}),
};

function getDotY(dotIndex: number) {
	return 0.5 * DOT_CONTAINER_WIDTH + dotIndex * DOT_CONTAINER_WIDTH;
}
export default class Steps extends React.Component<Props> {
	public render() {
		const topLineStyle = {
			marginTop: getDotY(0),
			height: getDotY(this.props.currentIndex) - getDotY(0),
		};
		const bottomLineStyle = {
			height: getDotY(this.props.steps.length - 1) - getDotY(this.props.currentIndex),
		};
		const dotStyle = (i: number) => {
			const topColor = this.props.dark ? Colors.LIGHT_GRAY5 : Colors.DARK_GRAY3;
			const botColor = this.props.dark ? Colors.DARK_GRAY5 : Colors.GRAY5;
			const currentColor = this.props.dark ? Colors.BLUE5 : Colors.BLUE3;
			let style = {};
			if (i < this.props.currentIndex) {
				style = { background: topColor };
			} else if (i === this.props.currentIndex) {
				style = { background: currentColor };
			} else {
				style = {
					border: "3px solid " + botColor,
					background: botColor,
				};
			}
			return style;
		};

		return (
			<div>
				<H1 {...styles.title}>Progress</H1>
				<div {...styles.container}>
					{this.props.steps.map((step, i) => (
						<div key={i} {...styles.element}>
							<div {...styles.dotContainer}>
								<div {...styles.dot} style={dotStyle(i)}>
									&nbsp;
								</div>
							</div>
							<div {...styles.elementText}>{step}</div>
						</div>
					))}
					<div {...styles.linesContainer}>
						<div {...styles.topLine(this.props.dark)} style={topLineStyle}>
							&nbsp;
						</div>
						<div {...styles.bottomLine(this.props.dark)} style={bottomLineStyle}>
							&nbsp;
						</div>
					</div>
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/FightRoom/Steps.tsx